<template>
    <div>
        <h1 style="font-size: 24px; color: black;">量级收入周报</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button class="std" type="primary"  @click="exportExcel" >导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="第几周" prop="dt" align="center"></el-table-column>
                <el-table-column label="日期范围" prop="scope" align="center"></el-table-column>
                <el-table-column label="量级" align="center">
                    <el-table-column  label="有价新增数">
                        <template  slot-scope="scope">
                            {{scope.row.totalRegister==null?'0.00':scope.row.totalRegister}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="总DAU">
                        <template  slot-scope="scope">
                            {{scope.row.totalActiveUser==null?'0.00':scope.row.totalActiveUser}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="有价新增占比">
                        <template  slot-scope="scope">
                            {{scope.row.registerRate==null?'0.00%':(scope.row.registerRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="周综合成本">
                        <template  slot-scope="scope">
                            {{scope.row.totalCost==null?'0.00':scope.row.totalCost.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="收入" align="center">
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.arpu==null?'0.00':scope.row.arpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ROI">
                        <template  slot-scope="scope">
                            {{scope.row.roi==null?'0.00%':(scope.row.roi*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchWeekDate,
        downloadData
    } from "@/http/outApi";
    import utils from '@/utils';
    export default {
        name: "WeekDataReport",
        data(){
            return{
                queryData:{
                    timeDate:['','']
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                dataList:[],
                loading:true,
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        // 把选择的第一个日期赋值给一个变量。
                        this.choiceDate = minDate.getTime();
                        // 如何你选择了两个日期了，就把那个变量置空
                        if (maxDate) this.choiceDate = ''
                    },
                    disabledDate: time => {
                        // 如何选择了一个日期
                        if (this.choiceDate) {
                            console.log(time.getTime(),66,this.choiceDate);
                            // *天的时间戳
                            const one = 30 * 24 * 3600 * 1000;
                            // 当前日期 - one = 7天之前
                            const minTime = this.choiceDate - one;
                            // 当前日期 + one = 7天之后
                            const maxTime = this.choiceDate + one;
                            return (
                                time.getTime() < minTime ||
                                time.getTime() > maxTime
                            )
                        }else{
                            return false
                        }
                    }
                }
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchWeekDate(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
            exportExcel(){
                let fileName = new Date().toLocaleString() + '量级收入周报.xlsx';
                downloadData(
                    '/report/exportWeek',
                    this.queryData,
                    fileName
                )
            }
        },
        created () {
            this.queryData.timeDate = [utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
            this.query();
        }
    }
</script>
sh
<style scoped>

</style>